import { HTMLAttributes } from 'react';

export function CentralizedLines({ children }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div className="flex items-center gap-4">
      <div className="h-px flex-1 bg-neutral-300" />
      {children}
      <div className="h-px flex-1 bg-neutral-300" />
    </div>
  );
}
